import { render, staticRenderFns } from "./BlackListUserForm.vue?vue&type=template&id=0f636bbc"
import script from "./BlackListUserForm.vue?vue&type=script&lang=js"
export * from "./BlackListUserForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports